export var defaultProps = {
    className: '',
    format: 'HH:mm:ss',
    onEnd: function () { },
    endText: '',
    seconds: 0,
    endDate: 0,
    startDate: 0,
    onPaused: function (value) { },
    onRestart: function (value) { },
    onChange: function (value) { },
    paused: false,
};
